import { useEffect } from "react";
import "./HeadLine.scss";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const HeadLine = (props) => {

  return (
    <div className="flex flex-auto flex-col md:flex-row">

      <div className="mb-3 sm:mb-6">
        <h1 class="font-medium sm:text-4xl bg-transparent text-2xl" style={{
          fontFamily: "Norwester, Poppins, sans-serif",
          textTransform: "uppercase",
          fontStyle: "normal",
        }}>
          Jazz Forum Arts Programming
        </h1>
      </div>
    </div>
  );
};
